import React, { useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DateTime } from 'luxon'

import { getTaxReport } from '../../../features/utility/utilitySlice'

import './TaxReportForm.css'
import CSelect from '../../../components/UI/CSelect'
import CButton from '../../../components/UI/CButton'
import Icon from '../../../components/UI/Icon'

const TaxReportForm = ({ onClose, onSuccess }) => {
    const dispatch = useDispatch()

    const { companyInfo, loading } = useSelector((state) => state.utility)

    const isLoading = loading.taxReport

    const currentYear = DateTime.now().year
    const burnStartYear = companyInfo?.burnstartdate
        ? DateTime.fromISO(companyInfo.burnstartdate).year
        : currentYear

    const taxYearOptions = useMemo(() => {
        const years = []
        for (let year = currentYear; year >= burnStartYear; year--) {
            years.push({ value: String(year), label: String(year) })
        }
        return years
    }, [currentYear, burnStartYear])

    const [selectedYear, setSelectedYear] = useState({ value: String(currentYear), label: String(currentYear) })
    const [validationError, setValidationError] = useState('')

    const handleYearChange = (option) => {
        setSelectedYear(option)
        if (validationError) setValidationError('')
    }

    const handleSubmit = async () => {
        if (!selectedYear?.value) {
            setValidationError('Please select a tax year')
            return
        }

        try {
            await dispatch(getTaxReport(selectedYear.value)).unwrap()
            if (onSuccess) onSuccess()
            if (onClose) onClose()
        } catch {
            // Error handled via snackbar in the thunk
        }
    }

    const handleCancel = () => {
        if (onClose) onClose()
    }

    return (
        <div className="tax-report-form">
            <span className="text-4">Select the tax year to generate a report for.</span>

            <CSelect
                label="Tax Year"
                options={taxYearOptions}
                value={selectedYear?.value}
                onChange={handleYearChange}
                required
                error={!!validationError}
                helperText={validationError}
            />

            <div className="tax-note">
                <div className="icon-wrapper">
                    <Icon name="info-circle" />
                </div>
                <span className="text-4">
                    <b>Please note:</b> Once you generate the Earnings report, we will send the report to you via email.
                </span>
            </div>

            <div className="tax-report-form-actions">
                <CButton
                    variant="outlined"
                    size="large"
                    onClick={handleCancel}
                    colorTheme="primary"
                    label="Cancel"
                    disabled={isLoading}
                />
                <CButton
                    variant="contained"
                    size="large"
                    onClick={handleSubmit}
                    colorTheme="primary"
                    label="Generate Report"
                    disabled={isLoading}
                />
            </div>
        </div>
    )
}

export default TaxReportForm
